import React from "react";
import PrivateRoute from "./PrivateRoute";
export default () => <PrivateRoute />;
